"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyProperty = void 0;
class PolicyProperty {
}
exports.PolicyProperty = PolicyProperty;
//# sourceMappingURL=PolicyProperty.js.map